import {
  createStage, createStagePlanning, deleteStagePlanning, getStagePlannings, getStagesByApartment, getStagesBySection, updateStage, updateStagePlanning, updateStagePlanningStages,
} from '@/api/stages'

export default {
  ADD_STAGE(a, data) {
    return createStage(data)
  },

  FETCH_STAGES_BY_SECTION({ commit }, data) {
    return new Promise((resolve, reject) => {
      getStagesBySection(data).then(response => {
        commit('SET_STAGES', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  FETCH_STAGES_BY_APARTMENT({ commit }, data) {
    return new Promise((resolve, reject) => {
      getStagesByApartment(data).then(response => {
        commit('SET_STAGES', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  FETCH_STAGE_PLANNINGS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getStagePlannings(data).then(response => {
        commit('SET_STAGE_PLANNINGS', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  EDIT_STAGE_PLANNING(a, data) {
    return updateStagePlanning(data)
  },

  EDIT_STAGE_PLANNING_STAGES(a, data) {
    return updateStagePlanningStages(data)
  },

  CREATE_STAGE_PLANNING(a, data) {
    return createStagePlanning(data)
  },

  DELETE_STAGE_PLANNING(a, data) {
    return deleteStagePlanning(data)
  },

  EDIT_STAGE(a, data) {
    return updateStage(data)
  },
}
